import { render } from "./AlertPopup.vue?vue&type=template&id=3308bef8&scoped=true"
import script from "./AlertPopup.vue?vue&type=script&lang=js"
export * from "./AlertPopup.vue?vue&type=script&lang=js"

import "./AlertPopup.vue?vue&type=style&index=0&id=3308bef8&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3308bef8"]])

export default __exports__